import { render, staticRenderFns } from "./ResAssignmentWithPath.vue?vue&type=template&id=087c53d2"
import script from "./ResAssignmentWithPath.vue?vue&type=script&lang=js"
export * from "./ResAssignmentWithPath.vue?vue&type=script&lang=js"
import style0 from "./ResAssignmentWithPath.vue?vue&type=style&index=0&id=087c53d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports